class cAdminAccount {
    constructor(page = 'account') {
        var self = this;
        $(function () { self.onload(page); });
    }
    onload(page) {
        var self = this;
        if (page == 'account') {
            var elBtnCancelSubscription = $('#cancel-subscription-btn');
            var elBtnUpdateSubscription = $('#update-subscription-btn');
            var elBtnUpgradeSubscription = $('#upgrade-subscription-btn');
            this.elAccountCancelSubscriptionForm = $('#cancel-subscription-form');
            this.elAccountSubscriptionInfoForm = $('#subscription-info-form');
            this.elAccountSubscriptionUpgradeForm = $('#subscription-upgrade-form');
            $(elBtnCancelSubscription).click(function (e) { return self.submitCancelSubscription(this, e); });
            $(elBtnUpdateSubscription).click(function (e) { return self.submitUpdateSubscription(this, e); });
            $(elBtnUpgradeSubscription).click(function (e) { return self.submitUpgradeSubscription(this, e); });
        }
        if (page == 'renew') {
            this.elPlanSelect = $('#plan_id');
            $(this.elPlanSelect).change(function (e) { return self.updateStripePlanSelection(this, e); });
        }
    }
    submitCancelSubscription(btn, e) {
        $(btn).button('loading');
        $(this.elAccountCancelSubscriptionForm).ajaxSubmit({
            url: URL_ADMIN + '/account/cancelsubscription/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location = '/login/logout';
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
    submitUpdateSubscription(btn, e) {
        $(btn).button('loading');
        $(this.elAccountSubscriptionInfoForm).ajaxSubmit({
            url: URL_ADMIN + '/account/updatesubscription/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
    submitUpgradeSubscription(btn, e) {
        $(btn).button('loading');
        $(this.elAccountSubscriptionUpgradeForm).ajaxSubmit({
            url: URL_ADMIN + '/account/upgradesubscription/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
    updateStripePlanSelection(btn, e) {
        $('#stripe-btn').data('amount', $('option:selected', this.elPlanSelect).attr('data-amount'));
        $('#stripe-btn').data('description', $('option:selected', this.elPlanSelect).attr('data-description'));
    }
}
